/**
 * Profile API — binding to the shared createProfileApi(http) factory in
 * packages/common, bound to web's apiClient singleton.
 */

import { apiClient } from "@/lib/api/client";
import { createProfileApi } from "@speakai/common/src/profile/api";

export type {
  UpdateProfileData,
  ChangePasswordData,
  NotificationPreferenceChange,
  MetaData,
  CompanyPreferences,
  CompanyPreferencesUpdate,
  VocabularyUpdateData,
  ImageSelectionType,
  AppearancePreferences,
  MenuPreferencesUpdate,
  MediaInsightPreferencesUpdate,
  CompanyNavDefaultsUpdate,
  AccountDeletionAnswer,
  PublicTranscriptionLanguage,
  AssignToItem,
  AIProviderName,
  AIProviderKeyPublic,
  AssistantTemplate,
  AiContextData,
} from "@speakai/common/src/profile/types";

export const {
  getProfile,
  updateProfile,
  updatePicture,
  changePassword,
  updateNotificationPreferences,
  updateAppearance,
  getPreferences,
  updatePreferences,
  updateMenuPreferences,
  updateMediaInsightPreferences,
  updateCompanyNavDefaults,
  updateVocabulary,
  updatePlatformLanguage,
  getCustomization,
  updateCustomization,
  updateMetaImage,
  removeMetaImage,
  requestDataExport,
  requestAccountDeletion,
  updateDeleteDataDuration,
  checkLinkAccounts,
  disconnectAccount,
  getTaxInfo,
  updateTaxInfo,
  getTranscriptionLanguages,
  checkCalendarPermission,
  getAssignToList,
  getProviderKeys,
  saveProviderKey,
  removeProviderKey,
  getAssistantTemplates,
  createAiContext,
  updateAiContext,
  deleteAiContext,
} = createProfileApi(apiClient);
